/* eslint-disable react/jsx-pascal-case */
import React from 'react';
import { bool, shape, string } from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { navigationalLayoutDataModel } from './dataModel';
import { NavigationalLayoutRenderer } from './NavigationalLayoutRenderer';

/**
 * Main job for this component is to fetch data. The useDataModel call will cause this component to rerender which is
 * why the rendering of the components is split into NavigationalLayoutRenderer so that they don't unnecessarily
 * rerender. Rerendering components can result in extra API calls and processing, we do not want that.
 */
export const NavigationalLayout = ({
  canonicalURL, customerType, pageId, storeId, pageTypeComponents, thdSEOBotDetection
}) => {

  const { data, loading, error } = useDataModel('navigationalLayout', {
    variables: {
      slug: pageId,
      customerType,
    },
  });

  if (!data || loading || error) {
    return null;
  }

  return (
    <NavigationalLayoutRenderer
      canonicalURL={canonicalURL}
      data={data}
      pageId={pageId}
      customerType={customerType}
      storeId={storeId}
      pageTypeComponents={pageTypeComponents}
      thdSEOBotDetection={thdSEOBotDetection}
    />
  );
};

NavigationalLayout.displayName = 'NavigationalLayout';

NavigationalLayout.dataModel = navigationalLayoutDataModel;

NavigationalLayout.propTypes = {
  canonicalURL: string,
  customerType: string.isRequired,
  pageTypeComponents: shape({}).isRequired,
  pageId: string.isRequired,
  storeId: string.isRequired,
  thdSEOBotDetection: bool
};

NavigationalLayout.defaultProps = {
  canonicalURL: null,
  thdSEOBotDetection: false
};
